module.exports = __webpack_public_path__ + "static/media/ic-profile.90148d2d.svg";